import React from "react";
import "./Ai_Readiness.css";

const Ai_Readiness = () => {
  const readinessPath = "/ai-readiness";

  return (
    <>
      <div className="Ai_Readiness_container">
        <div className="digital_section_title_subsections">
          <h6 className="common-title ">Is your business</h6>{" "}
          <em>actually ready</em> <h6 className="common-title ">for AI?</h6>
          <p>check the AI readiness of your company within 4min</p>
        </div>
        <div className="btn_container">
          <a
            className="btn-teal"
            href={readinessPath}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Started
          </a>
        </div>
      </div>
    </>
  );
};

export default Ai_Readiness;
